module.exports = __webpack_public_path__ + "img/api-world.96c994ed.svg";